import { Device } from "../Device";
import { LoaderEvent } from "../events/LoaderEvent";
import { BaseLoader } from "./BaseLoader";

export class SoundLoader extends BaseLoader {
    private _data: AudioBuffer = null;

    constructor(src: string, cacheTimestamp?: string, prependURL?: string, id?: string) {
        super(src, cacheTimestamp, prependURL, id);
    }

    getData(): any {
        return this._data;
    }

    protected getResponseType(): string {
        return "arraybuffer";
    }

    protected onLoaded(event: any) {
        // TODO: make sure all loaders handle this case correctly
        if (event == undefined) {
            // the "load" method was called but the content has already been loaded
            this.dispatchEvent(new LoaderEvent(LoaderEvent.COMPLETE, this._data));
            return;
        }

        // TODO: if there is no sound support, don`t even make http request
        if (!Device.isSoundSupported()) {
            this._state = BaseLoader.STATE_ERROR;
            this.dispatchEvent(new LoaderEvent(LoaderEvent.ERROR));
        }
        else {
            var self = this;
            // TODO: remove audioContextInstance, create package sound in the library
            // and create classes that share this instance, it should not be global
            if ((window as any).audioContextInstance == null) {
                (window as any).audioContextInstance = new (Device.getAudioContext())();
            }
            var audioContext: AudioContext = (window as any).audioContextInstance;
            audioContext.decodeAudioData(this._request.response, function (buffer) {
                self.onBufferDecoded(buffer);
            }, function () {
                self.onBufferDecodeError();
            });
        }
    }

    // TODO: specify the type of error that has occured(loading erro, decoding error....)
    protected onError(event: any) {
        this.dispatchEvent(new LoaderEvent(LoaderEvent.ERROR));
    }

    private onBufferDecoded(buffer: AudioBuffer) {
        this._data = buffer;
        this.dispatchEvent(new LoaderEvent(LoaderEvent.COMPLETE, this._data));
    }

    private onBufferDecodeError() {
        this._state = BaseLoader.STATE_ERROR;

        this.dispatchEvent(new LoaderEvent(LoaderEvent.ERROR));
    }
}


